import React from "react";
import { TESTIMONIALS } from "@/data/site";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="py-20 md:py-28 px-5 md:px-8 bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center flex flex-col items-center">
          <SectionHeading
            eyebrow="Testimonials"
            title="Loved by travelers around the world"
            subtitle="Stories from real people who explored the world with Malviya Travel."
            align="center"
          />
        </div>

        <Reveal>
          <Carousel opts={{ align: "start", loop: true }} className="mt-14">
            <CarouselContent className="-ml-4">
              {TESTIMONIALS.map((t, i) => (
                <CarouselItem key={t.name} className="pl-4 md:basis-1/2 lg:basis-1/3">
                  <div
                    data-testid={`testimonial-${i}`}
                    className="bg-white rounded-2xl p-6 md:p-7 border border-gray-100 shadow-[0_4px_24px_-8px_rgba(11,61,145,0.15)] h-full flex flex-col"
                  >
                    <Quote className="w-8 h-8 text-[#F9B233]/60" />
                    <p className="mt-4 text-[15px] text-[#333] leading-relaxed italic flex-1">"{t.text}"</p>
                    <div className="mt-5 flex items-center gap-1 text-[#F9B233]">
                      {Array.from({ length: 5 }).map((_, j) => <Star key={j} className="w-4 h-4 fill-current" />)}
                    </div>
                    <div className="mt-5 flex items-center gap-3 pt-5 border-t border-gray-100">
                      <img src={t.img} alt={t.name} loading="lazy" className="w-12 h-12 rounded-full object-cover" />
                      <div>
                        <p className="font-semibold text-[#0B3D91]">{t.name}</p>
                        <p className="text-xs text-gray-500">{t.city}, India</p>
                      </div>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <CarouselPrevious data-testid="testimonial-prev" className="hidden md:flex -left-4 bg-white border-[#0B3D91]/20 text-[#0B3D91] hover:bg-[#0B3D91] hover:text-white" />
            <CarouselNext data-testid="testimonial-next" className="hidden md:flex -right-4 bg-white border-[#0B3D91]/20 text-[#0B3D91] hover:bg-[#0B3D91] hover:text-white" />
          </Carousel>
        </Reveal>
      </div>
    </section>
  );
}
